// extracted by mini-css-extract-plugin
module.exports = {"root":"AppPage_root__2MQIe","instagram":"AppPage_instagram__2PKsS","facebook":"AppPage_facebook__3mXPd"};